module.exports = __webpack_public_path__ + "static/media/blob-shape-3.3762103c.svg";